import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { kurzfristigerAufenthaltPath, langfristigerAufenthaltPath } from '../app-routing.module';

@Injectable({ providedIn: 'root' })
export class AppService {

  private readonly _path$ = new BehaviorSubject("");

  constructor(private readonly router: Router) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(event => this._path$.next(event.urlAfterRedirects));
  }

  isCVisum(): boolean {
    return this._path$.value.includes(kurzfristigerAufenthaltPath);
  }

  isCVisumWindow(): boolean {
    return window.location.pathname.includes(kurzfristigerAufenthaltPath);
  }

  isDVisum(): boolean {
    return this._path$.value.includes(langfristigerAufenthaltPath);
  }

  isDVisumWindow(): boolean {
    return this._path$.value.includes(langfristigerAufenthaltPath);
  }
}
